import { OfferMemberStatus, TOfferMember } from './types';

export const memberIsPending = (member: TOfferMember): boolean => (
  member.status === OfferMemberStatus.PENDING
  || member.status === OfferMemberStatus.PENDING_DELETION
  || member.status === OfferMemberStatus.PENDING_UPDATE
);
